<template>
    <div>
        <v-container class="app-breadcrumbs-container">
            <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
                <v-icon slot="divider">chevron_right</v-icon>
                <template slot="item" slot-scope="props">
                    <router-link
                        :to="props.item.to"
                        :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
                    >
                        {{ props.item.text }}
                    </router-link>
                </template>
            </v-breadcrumbs>
        </v-container>
        <v-container>
            <v-layout
                pa-3
                class="order-item"
                :key="index"
                v-for="(item, index) in orderList"
                @click.stop="goToDetail(item.guid)"
            >
                <v-layout column>
                    <v-flex class="number">
                        {{ $t("home.reserva.reserva_date") }}： {{ (item.date || '') + ' ' + (item.time  || '')}}
                    </v-flex>
                    <v-flex class="time">
                        {{ $t("order.time") }}：{{
                            moment(item.createTime).format("YYYY-MM-DD HH:mm")
                        }}
                    </v-flex>
                </v-layout>
                <v-layout column>
                    <v-flex class="status">
                        {{ $t("order.status") }}： {{ appointmentOrderStatusList[item.status] }}
                    </v-flex>
                    <!-- <v-flex class="status">桌位状态： 空闲</v-flex> -->
                </v-layout>
                <v-layout column align-end justify-center>
                    <v-flex class="status">
                        {{ $t("home.reserva.number") }}：{{ item.number }}
                    </v-flex>
                    <v-flex class="status">
                        {{ $t("home.reserva.phone") }}：{{ item.phone }}
                    </v-flex>
                </v-layout>
                <!-- bengin 支付 -->
                <form
                    name="from"
                    :action="redsysParams.form_action"
                    method="POST"
                    id="myForm"
                >
                    <input
                        type="hidden"
                        name="Ds_SignatureVersion"
                        :value="redsysParams.Ds_SignatureVersion"
                    />
                    <input
                        type="hidden"
                        name="Ds_MerchantParameters"
                        :value="redsysParams.Ds_MerchantParameters"
                    />
                    <input
                        type="hidden"
                        name="Ds_Signature"
                        :value="redsysParams.Ds_Signature"
                    />
                </form>

                <v-layout
                    v-if="
            item.paymentStatus == 0 &&
              item.paymentMethod == 'VisaOnline' &&
              isOpenVisaOnline
          "
                    justify-center
                >
                    <v-btn
                        color="primary"
                        :loading="item.isPaying"
                        @click.stop="redsystransaction(item.guid, index)"
                    >
                        {{ $t("order.pay") }}
                    </v-btn>
                </v-layout>
                <!-- end 支付 -->
            </v-layout>
        </v-container>
        <div class="load-tip">
            {{
                this.isLoading
                    ? $t("order.loading")
                    : !this.hasMore
                        ? $t("order.more")
                        : ""
            }}
        </div>
    </div>
</template>

<script>
import order from "@/api/order";
import moment from "moment";
import $ from "jquery";
import { fixed } from "../../utils";
import { mapGetters, mapState } from "vuex";

export default {
    data() {
        return {
            showAlert: false,
            orderList: [],
            moment: moment,
            pageIndex: 1,
            hasMore: true,
            isLoading: true,

            redsysParams: {},

            isPaying: false
        };
    },
    created() {
        this.loadOrder();
    },

    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },

    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },

    computed: {
        ...mapGetters(["payStatusList", "appointmentOrderStatusList"]),
        ...mapState(["payAction", "storeInfo", 'userInfo']),
        breadcrumbs() {
            return [
                {
                    to: { name: "home" },
                    disabled: false,
                    text: this.$t("breadcrumbs.home")
                },
                {
                    to: { name: "order/list" },
                    disabled: false,
                    text: this.$t("breadcrumbs.appointment")
                }
            ];
        },
        // 返回true表示店铺开启线上支付
        isOpenVisaOnline() {
            let supportedPaymentMethod = this.storeInfo.supportedPaymentMethod.split(
                ","
            );
            let index = supportedPaymentMethod.indexOf("VisaOnline");
            return index != -1;
        }
    },
    methods: {
        async loadOrder() {
            this.isLoading = true;
            try {
                const res = await order.loadAppointmentOrder({ pageIndex: this.pageIndex, customer_guid: this.userInfo && this.userInfo.guid });
                if (!res.data.isError) {
                    this.orderList = this.orderList.concat(res.data.data.collection);
                    this.pageIndex = res.data.data.pageIndex;
                    if (res.data.data.collection.length == 0) {
                        this.hasMore = false;
                    }
                    this.isLoading = false;
                }
            } catch (e) {
                this.isLoading = false;
            }
        },
        handleScroll() {
            const that = this;
            let scrollTop = $("body").scrollTop();
            let scrollHeight = $(document).height();
            let windowHeight = $("body").height();
            if (scrollTop + windowHeight == scrollHeight) {
                if (!that.hasMore) {
                    return;
                }
                if (that.isLoading) {
                    return;
                }
                that.pageIndex += 1;
                that.loadOrder();
            }
        },
        goToDetail(guid) {
            this.$router.push({ name: "order/appointment/detail", params: { guid } });
        },

        async redsystransaction(guid, index) {
            this.orderList[index].isPaying = true;
            let payload = {
                orderGuid: guid,
                customerLanguage: 1,
                OKUrl: window.location.origin + "/#/order/list",
                UrlKO: window.location.origin + "/#/order/list"
            };
            try {
                const {
                    data: { isError, data }
                } = await order.redsystransaction(payload);

                if (isError) {
                    return;
                }

                this.redsysParams = data;

                setTimeout(() => {
                    document.getElementById("myForm").submit();
                    this.orderList[index].isPaying = false;
                }, 1000);
            } catch (e) {
                console.log(e);
            }
        }
    },

    filters: {
        fixed
    }
};
</script>

<style scoped lang="sass" src="./order-list.sass"></style>